import { render, staticRenderFns } from "./dg-sign-entry.vue?vue&type=template&id=44bdffd9&scoped=true"
import script from "./dg-sign-entry.vue?vue&type=script&lang=js"
export * from "./dg-sign-entry.vue?vue&type=script&lang=js"
import style1 from "./dg-sign-entry.vue?vue&type=style&index=1&id=44bdffd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdffd9",
  null
  
)

export default component.exports